import { render, staticRenderFns } from "./nimp_text.vue?vue&type=template&id=5da5acd6&scoped=true&"
import script from "./nimp_text.vue?vue&type=script&lang=js&"
export * from "./nimp_text.vue?vue&type=script&lang=js&"
import style1 from "./nimp_text.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5acd6",
  null
  
)

export default component.exports